import { useLang } from "@/contexts/LanguageContext";
import { t } from "@/translations";
import { mainSpeakers } from "@/mocks/speakers";

export default function MainSpeakers() {
  const { lang } = useLang();
  const tr = t[lang].mainSpeakers;
  const isEn = lang === "en";

  return (
    <section id="teachers" className="w-full py-16 bg-[#fafafa]">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12">
          {tr.heading}
        </h2>

        <div className="flex flex-col gap-10">
          {mainSpeakers.map((speaker) => {
            const name = isEn ? speaker.nameEn : speaker.name;
            const role = isEn ? speaker.roleEn : speaker.role;
            const description = isEn ? speaker.descriptionEn : speaker.description;
            const country = isEn ? speaker.countryEn : speaker.country;

            const nameParts = name.split("\n");
            const roleParts = role.split("\n");

            const card = (
              <div
                key={speaker.id}
                className="flex flex-col md:flex-row gap-6 bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-[#c8e6c9] transition-colors"
              >
                {/* Image */}
                <div className="w-full md:w-56 flex-shrink-0 h-64 md:h-auto overflow-hidden">
                  <img
                    src={speaker.image}
                    alt={name.replace("\n", " ")}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                {/* Content */}
                <div className="flex flex-col justify-center gap-2 p-5 md:p-6">
                  <h3 className="text-xl font-bold text-gray-900 leading-tight">
                    {nameParts.map((part, i) => (
                      <span key={i}>
                        {part}
                        {i < nameParts.length - 1 && <br />}
                      </span>
                    ))}
                  </h3>
                  <p className="text-[#4caf50] text-sm font-medium leading-snug">
                    {roleParts.map((part, i) => (
                      <span key={i}>
                        {part}
                        {i < roleParts.length - 1 && <br />}
                      </span>
                    ))}
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed mt-1">{description}</p>
                  <p className="text-gray-400 text-xs mt-1">{country}</p>
                </div>
              </div>
            );

            return speaker.link ? (
              <a key={speaker.id} href={speaker.link} target="_blank" rel="noopener noreferrer" className="block">
                {card}
              </a>
            ) : (
              <div key={speaker.id}>{card}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
